export const FileTourData = [
  {
    image: 'https://res.cloudinary.com/samvibes/image/upload/v1700220343/onboarding/demo-1.gif',
    title: 'Get started with Files!',
    content: [
      { option: 'Click on "Add new task" to quickly add new issues.' },
      { option: 'Change the status of your task from the list view' },
      { option: 'Choose an assignee for your task' },
      { option: 'Add a date to your task' },
      { option: 'Pick a priority for your task' },
      { option: 'Quickly add a label to your task' },
    ],
  },
  {
    image: 'https://res.cloudinary.com/samvibes/image/upload/v1700220343/onboarding/demo-2.gif',
    title: '',
    content: [
      { option: 'Add more custom fields to your task by clicking on property.' },
      { option: 'Add a subtask to the parent task' },
      { option: 'Write a description for the task' },
    ],
  },
  {
    image: 'https://res.cloudinary.com/samvibes/image/upload/v1700220343/onboarding/demo-3.gif',
    title: '',
    content: [
      { option: 'Add and view comments plus attachments for this task' },
      { option: 'View every change to the task with the history tab' },
      { option: 'Start watching this task and get notified about changes' },
      { option: 'Share this task with anyone and track time on it' },
    ],
  },
  {
    image: 'https://res.cloudinary.com/samvibes/image/upload/v1700220343/onboarding/demo-4.gif',
    title: '',
    content: [{ option: 'Automate your tasks simply' }, { option: 'Add more views to your file' }],
  },
];
